import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__spinner_mjs_3c9b11bb__ from "./spinner.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__internal_DynamicLink_mjs_d5a03e92__ from "../internal/DynamicLink.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_use_keyboard_shortcut_mjs_75bbbe7f__ from "../hooks/use-keyboard-shortcut.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__tooltip_mjs_e6c527ba__ from "./tooltip.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_use_window_size_mjs_0c5b66fd__ from "../hooks/use-window-size.mjs";
const buttonVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("inline-flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap rounded-lg text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive active:scale-90 transform-gpu", {
    variants: {
        variant: {
            default: "bg-accent-light text-grayscale-darkest",
            secondary: "bg-[rgba(116,255,241,0.1)] text-brand-primary",
            tertiary: "bg-[rgba(163,163,163,0.1)] text-white hover:text-white/70",
            destructive: "bg-alert-background/50 text-alert-primary hover:bg-alert-background/60",
            ghost: "hover:bg-grayscale-dark hover:text-foreground text-foreground/70",
            outline: "cursor-pointer !px-3 text-white !font-normal h-[32px] hover:!text-white/50 bg-grayscale-dark border border-white/10 flex flex-row items-center justify-between !text-[13px]"
        },
        size: {
            default: "h-9 rounded-xl px-4 py-2 has-[>svg]:px-3",
            sm: "h-8 gap-1.5 px-3 has-[>svg]:px-2.5 text-[11px]",
            lg: "h-10 px-6 has-[>svg]:px-4 text-base",
            xl: "h-11 px-8 text-lg",
            icon: "size-9",
            icon_sm: "size-8"
        },
        isMinimal: {
            true: "!bg-transparent",
            false: ""
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default",
        isMinimal: false
    }
});
const ButtonLink = ({ href, linkProps, children, ...rest })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__internal_DynamicLink_mjs_d5a03e92__.DynamicLink, {
        href: href,
        ...linkProps,
        ...rest,
        children: children
    });
const Button = ({ children, className, variant, size, isMinimal, disabled = false, type = "button", onClick, onCommandClick, isLoading: _isLoading, href, linkProps, target, hotkey, tooltip, ...props })=>{
    const styles = (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(buttonVariants({
        variant,
        size,
        isMinimal,
        className
    }));
    const [animateButtonPress, setAnimateButtonPress] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [didReturnPromise, setDidReturnPromise] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(null);
    const isLoading = _isLoading || didReturnPromise;
    const { isCommandPressed } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_keyboard_shortcut_mjs_75bbbe7f__.useCommandKey)();
    const screenSize = (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_window_size_mjs_0c5b66fd__["default"])();
    const click = async (e)=>{
        const onClickUsing = isCommandPressed && void 0 !== onCommandClick ? onCommandClick : onClick;
        if (onClickUsing) {
            if (didReturnPromise) return;
            if (e) e.preventDefault();
            const onClickResult = onClickUsing(e);
            if (onClickResult instanceof Promise) {
                if (e) e.preventDefault();
                setDidReturnPromise(true);
                await onClickResult;
                setDidReturnPromise(null);
            }
        }
    };
    (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_keyboard_shortcut_mjs_75bbbe7f__["default"])({
        hotkey,
        action: async ()=>{
            setAnimateButtonPress(true);
            await click(void 0);
            setTimeout(()=>{
                setAnimateButtonPress(false);
            }, 100);
        }
    });
    const buttonContent = void 0 !== href ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ButtonLink, {
        href: href,
        linkProps: linkProps,
        className: styles,
        onClick: onClick,
        target,
        children: children
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
        type: type,
        onClick: click,
        className: styles,
        disabled: disabled,
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    style: {
                        opacity: isLoading ? 0 : 1,
                        transform: isLoading ? "scale(0)" : animateButtonPress ? "scale(0.9)" : "scale(1.0)",
                        transition: "transform 0.1s ease-in-out, opacity 0.1s ease-in-out"
                    },
                    className: " flex flex-row gap-2 justify-center items-center",
                    children: children
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    style: {
                        position: "absolute",
                        pointerEvents: "none",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        opacity: isLoading ? 1 : 0,
                        transform: isLoading ? "scale(1.0)" : "scale(0)",
                        transition: "transform 0.2s ease-in-out, opacity 0.2s ease-in-out"
                    },
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__spinner_mjs_3c9b11bb__.SOverlaySpinner, {
                        overlayColor: "rgba(0,0,0,0)"
                    })
                })
            ]
        })
    });
    const showTooltip = (hotkey || tooltip) && !tooltip?.disabled && (screenSize?.width || 100) > 768;
    return showTooltip ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_e6c527ba__.Tooltip, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_e6c527ba__.TooltipTrigger, {
                asChild: true,
                children: buttonContent
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_e6c527ba__.TooltipContent, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    className: "!max-w-[200px] inline",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "-my-3 -mx-1 inline-flex items-center justify-center gap-3 ",
                        children: [
                            tooltip?.content && ("string" == typeof tooltip.content ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                className: "text-sm font-normal pl-1",
                                children: tooltip.content
                            }) : tooltip.content),
                            hotkey && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                className: "flex flex-row items-center justify-center gap-1",
                                children: (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_keyboard_shortcut_mjs_75bbbe7f__.formatKeyboardShortcut)(hotkey).map((key, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                        className: "text-white texm-xs bg-white/10 border border-white/10 font-medium tracking-wider rounded-md flex flex-row items-center justify-center w-[22px] h-[22px]",
                                        children: 0 === index ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            children: key
                                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "font-mono",
                                            children: key
                                        })
                                    }, index))
                            })
                        ]
                    })
                })
            })
        ]
    }) : buttonContent;
};
Button.displayName = "Button";
export { Button, buttonVariants };
